import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';
import Base64 from 'js-base64';
import commmonWebConfig from "@/utils/config";
var ajaxSubmit = {};


ajaxSubmit.allUrl={
    /*********首页***********/
   // "cities":"/V1/cities?ipCity=1",
   // "configs":"/adConfig/appInfo/configInfo",
   // "eventInfo":"/V1/configs/eventInfo",
   // "carBrands":"/V1/carBrands",
   // "hotBrand":"/V1/carBrands/hotBrand",
   // "carStyles":"/V1/carStyles",
   // "hotStyles":"/V1/carStyles/hotStyles",
   "applyOptionList":"/aconfig/tcj/applyOptionList",
   "checkPosition":"/aconfig/tcj/checkPosition",
   "cities":"/baseData/city/location", // http://api.tuanche.com/baseData/city/location
   "configs":"/aconfig/appInfo/configInfo", // http://api.tuanche.com/adConfig/appInfo/configInfo?cityId=10&count=5
   "eventInfo":"/aconfig/appInfo/eventInfo", // http://api.tuanche.com/adConfig/appInfo/eventInfo?cityId=10
   "carBrands":"/baseData/car/tcBrandCounts",  // http://api.tuanche.com/baseData/car/tcBrandCounts?cityId=10
   "hotBrand":"/baseData/car/tcHotBrand",  // http://api.tuanche.com/baseData/car/tcHotBrand?cityId=10&pageSize=4
   "carStyles":"/baseData/car/tcCarStyleCounts", // http://api.tuanche.com/baseData/car/tcCarStyleCounts?cityId=10
   "hotStyles":"/baseData/car/tcHotCarStyle", // http://api.tuanche.com/baseData/car/tcHotCarStyle?cityId=10&pageSize=10

   /*************新版团车节页面**************/
   /**报名页***/
   "tcj":"/aconfig/tcj",
   /**完善页***/
   "applySupplement":"/aconfig/tcj/applySupplement",
   /**报名页***/
   "suc":"aconfig/tcj/suc",
   /**提交报名信息***/
   "applyForTcjAsyn":"/aconfig/tcj/applyForTcjAsyn",
   /**提交完善信息***/
   "supplementForM":"/aconfig/tcj/supplementForM",
   "saveRRcarInfo":"/aconfig/tcj/saveRRcarInfo",

   /***********************************************/
   /**团车保障***/
   "tcBaoZheng":"/aconfig/periods/tcBaoZheng",
   /**报名人数、车型***/
   "tcStyle":"/aconfig/tcj/",
   /**评价***/
   "tcCommentInfo":"/aconfig/periods/tcCommentInfo?",
   /**地区选择***/
   "getAreaList":"/aconfig/tcj/getAreaList",
   /**购车方式**/
   "buyWays":"/aconfig/appInfo/buyWays",
   /*完善信息选择地区*/
   "getAreaList":"/aconfig/tcj/getAreaList",
   /*获取车型版本信息*/
    "tcModel":"/baseData/car/tcModel",
    /*获取品牌*/
    "tcBrand":"/baseData/car/tcBrand",
	/*获取车型*/
    "baseDataTcStyle":"/baseData/car/tcStyle",

    "tcStyleBySolr":"/baseData/car/tcStyleBySolr",
	/*获取城市*/
    "openCitys":"/baseData/city/openCitys",
    
    /*获取验证码*/
   "sendTgtValidCode":"/aconfig/tcj/sendMessageCode",
    /*AB测*/
    "abTest":"/aconfig/tcj/abTest",

  /***************车型对比库*****************/
  "comparisonBrandList":"/autostorage/api/masterbrand/list",
  "comparisonCarStyleList":"/autostorage/api/brand/listbycmid",
  "comparisonModelList":"/autostorage/api/carmodel/list",
  "comparisonList":"/autostorage/api/carmodel/params/list",
  "comparisonListbycarids":"/autostorage/api/carmodel/listbycarids",
  "getLocatingCity":"/baseData/city/location",
   "wechatrAuth": "/bargain/weiXinAuth/weChat_shareConf",

  /*************分销项目报名推送报名信息*******/
  "saveroll":"/distribute/enroll/saveroll",
  /* 私人定制*/
   "addApplyData":"/options/getOptions",
   "addApplyCustom" :"/options/addApplyCustom",
     /*拼团*/
    "groupbasic":"/groupbuy/groupbuy/basic",//基本信息
    "groupbanners":"/groupbuy/groupbuy/banners",//轮播
    "grouprulers":"/groupbuy/groupbuy/rulers",
    "groupusers":"/groupbuy/groupbuy/users",
    "applyGroupBuy":"/groupbuy/groupbuy/applyGroupBuy",
    "groupCounts":"/groupbuy/groupbuy/counts",
    "grouplistPage":"/groupbuy/groupbuy/listPage",

  /*推送报名信息*/
  "saveroll":"/distribute/enroll/saveroll",
   //三线城市
   "initpagedata":"/aconfig/tcj",
// 新增经销商
  "getCustomerList":"/aconfig/customer/getCustomerList",
//
///***************车型对比库*****************/
//"comparisonBrandList":"/api/masterbrand/list",
//"comparisonCarStyleList":"/api/brand/listbycmid",
//"comparisonModelList":"/api/carmodel/list",
//"comparisonList":"/api/carmodel/params/list",
//"comparisonListbycarids":"/api/carmodel/listbycarids",



  /**********************查违章******************************/
  //发送验证码
  //参数 phone
  "sendValidateCode":"/baseData/violate/sendValidateCode",
  //城市简称列表
  //参数 无
  "violateCityAbbrList":"/baseData/violate/cityAbbrList",
  //查询违章
  //参数 phone 手机号
  //     code  验证码
  //     hphm  ???
  //     hpzl  ???
  //     engineno ???
  //     classno ???
  "violationData":"/baseData/violate/violationData",
  
  
  /**********************计算器******************************/
  "calcultorSend":"/tuanche-kit-api/calculator/save",
  "calcultorShare":"/tuanche-kit-api/calculator/detail",
}

ajaxSubmit.signUrl = [
  /*************对比车型库***************/ 
  // {
  //   url:"/autostorage/api/masterbrand/list",
  //   type:"comparison"
  // },
  // {
  //   url:"/autostorage/api/brand/listbycmid",
  //   type:"comparison"
  // },
  // {
  //   url:"/autostorage/api/carmodel/list",
  //   type:"comparison"
  // },
  // {
  //   url:"/autostorage/api/carmodel/params/list",
  //   type:"comparison"
  // },
  // {
  //   url:"/autostorage/api/carmodel/listbycarids",
  //   type:"comparison"
  // },
  /*************对比车型库***************/  
  /*************M站报名接口等***************/ 
  {
    url:"/aconfig/tcj/applyForTcjAsyn",
    type:"aconfig"
  },
  {
    url:"/aconfig/tcj/supplementForM",
    type:"aconfig"
  }
  /*************M站报名接口等***************/ 
];
//获取签名的url
var signAjax = {
  //"comparison":"//t.login.tuanche.com/key/curinfo",
  "aconfig":commmonWebConfig.tuancheapi + "/aconfig/tcj/signParam"
  //"adConfig":"//172.16.3.138:8080" + "/adConfig/tcj/signParam"

};

ajaxSubmit.ajax = function(option){
    //默认data传值
    option.data = option.data ? option.data : {};
    //url, data, success, cache, alone, async, type, dataType, error
    var url = option.url;
    var data = option.data;
    var type = option.type || 'post';//请求类型
    var dataType = option.dataType || 'json';//接收数据类型
    var async = option.async || true;//异步请求
    var cache = option.cache || false;//浏览器历史缓存
    var contentType = option.contentType || 'application/x-www-form-urlencoded; charset=UTF-8';
    if(typeof(option.headers) != "undefined"){
      option.headers.platform = 4;
      option.headers.source = 1;
    }
    var headers = option.headers || { "platform":4 , "source":1 }
    var success = function (data) {
            Indicator.close();
            if(data.responseHeader.status != 200){//回传非200的code
              //返回结果集提示去掉
                // Toast({
                //   message: data.responseHeader.message,
                //   position: 'middle',
                //   duration: 2000
                // });
            }
            option.success ? option.success(data) : "";
        };
    var error = function (jqXHR, textStatus, errorThrown) {
            Indicator.close();
            Toast({
              message: '请求失败',
              position: 'middle',
              duration: 2000
            });
            option.error ? option.error() : "";
    };


    /***************接口sign加密***************/

    
    var curSignUrl = "";
    function getSign(params, time, version, key) {
        if (typeof params == "string") {
            return paramsStrSort(params);
        } else if (typeof params == "object") {
          var arr = [];
          for (var i in params) {
              if(params[i] != undefined){
                arr.push((i + "=" + params[i]));
              }
            }
          }
        return paramsStrSort(arr.join(("||")),time,version,key);
    }
    

    function paramsStrSort(paramsStr,time,version,key) {
        var url = paramsStr;
        //console.log(url);
        var urlStr = url.split("||").sort().join("&");
        var newUrl = urlStr + '&key=' + key +'&time='+ time;
        console.log(newUrl);
        console.log( md5(newUrl),5555555555555555555555555);
        return md5(newUrl);
    }

    //传入url  判断是否需要检验
    function isSign(url){
      var isSign = false;
      for(var  i in ajaxSubmit.signUrl){
        if(url.indexOf(ajaxSubmit.signUrl[i].url) != -1){
          isSign = true;
          curSignUrl = signAjax[ajaxSubmit.signUrl[i].type];
        }
      };
      return isSign
    }
     /***************接口sign加密***************/
    if(isSign(url)){
      $.ajax({
        url:curSignUrl,
        type:"get",
        dataType:"json",
        headers: headers,
        success:function(signData){
          console.log(signData);
          //var sign = getSign(data, signData.tctimestamp, signData.kv , signData.key);
          for(var i in data){
            if((i == "phone" || i == "name") && url.indexOf("/aconfig/tcj/applyForTcjAsyn") != -1){
              console.log(data[i]);
              data[i] = Base64.Base64.btoa(encodeURIComponent(data[i]));
              console.log(data[i])
            }
          };
          var sign = getSign(data, signData.response.result.authTime, signData.response.result.authVer , signData.response.result.authSecKey);
          //data = data + "&sign=" + sign + "&version=" + signData.authVer + "&time=" + signData.time;
          data.sign = sign;
          data.version = signData.response.result.authVer;
          data.time = signData.response.result.authTime;
          //data()
          console.log(data);
          $.ajax({
              url: url,
              data: data,
              type: type,
              contentType: contentType,
              dataType: dataType,
              async: async,
              timeout:50000,
              success: success,
              error: error,
              headers: headers
          });
        },
        error:function(){
          console.log("post获取签名失败")
        }
      }) 
    }else{
      $.ajax({
          url: url,
          data: data,
          type: type,
          contentType: contentType,
          dataType: dataType,
          async: async,
          timeout:50000,
          success: success,
          error: error,
          headers:headers
      });
    }
      
}

export default ajaxSubmit;


// WEBPACK FOOTER //
// ./src/utils/ajaxSubmit.js